import React from "react";
import "./success.css";

const Success = () => {
  return (
    <>
      <div className="successPage">
        <h3>
          The deposit has been saved. It will become active when the
          administrator checks statistics.
        </h3>
      </div>
    </>
  );
};

export default Success;
